"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSegmentCollection = void 0;
var segmentCollection_1 = require("./segmentCollection");
Object.defineProperty(exports, "startSegmentCollection", { enumerable: true, get: function () { return segmentCollection_1.startSegmentCollection; } });
//# sourceMappingURL=index.js.map